"use client";

import { useSyncExternalStore } from "react";

const CLOSED = { isOpen: false, redirect_to: null };

let state = CLOSED;
const listeners = new Set();

const emitChange = () => listeners.forEach((listener) => listener());

/**
 * باز کردن صفحه‌ی ورود.
 *
 * به صورت پیش‌فرض بعد از ورود، کاربر در همان صفحه‌ای می‌ماند که از آن اقدام به
 * ورود کرده است. اگر مقصد مشخصی لازم است (مثلا دکمه‌ی «حساب کاربری») مسیر آن را
 * به عنوان `redirect_to` بدهید.
 */
export const openAuthModal = (redirect_to = null) => {
    state = { isOpen: true, redirect_to };
    emitChange();
};

export const closeAuthModal = () => {
    state = CLOSED;
    emitChange();
};

const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

const getSnapshot = () => state;
const getServerSnapshot = () => CLOSED;

export const useAuthModal = () =>
    useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);


/*
 * رفتن از مودال ورود به صفحه‌ای مثل «قوانین و مقررات» و برگشتن با دکمه‌ی بک.
 *
 * مودال فقط یک state سراسری است و در history ثبت نمی‌شود؛ پس بعد از بک، کاربر
 * صفحه‌ی قبلی را بدون مودال می‌دید. مسیر مبدا در sessionStorage نگه داشته
 * می‌شود تا AuthModalRoot بعد از برگشت (popstate) مودال را دوباره باز کند.
 */
const RETURN_KEY = "jmt-auth-modal-return";

const normalize_path = (path) => (path || "/").replace(/\/+$/, "") || "/";

export const leaveAuthModalFor = (target_href) => {
    try {
        sessionStorage.setItem(
            RETURN_KEY,
            JSON.stringify({
                from: normalize_path(window.location.pathname),
                target: normalize_path(target_href),
                redirect_to: state.redirect_to,
            })
        );
    } catch {}
    closeAuthModal();
};

const read_return = () => {
    try {
        return JSON.parse(sessionStorage.getItem(RETURN_KEY) || "null");
    } catch {
        return null;
    }
};

const clear_return = () => {
    try {
        sessionStorage.removeItem(RETURN_KEY);
    } catch {}
};

/** اگر کاربر به صفحه‌ی مبدا برگشته، مودال را دوباره باز می‌کند. */
export const reopenAuthModalIfReturned = () => {
    const saved = read_return();
    if (!saved || normalize_path(window.location.pathname) !== saved.from) return;
    clear_return();
    openAuthModal(saved.redirect_to);
};

/** با رفتن به هر صفحه‌ای غیر از صفحه‌ی قوانین، برگشت دیگر مودال را باز نکند. */
export const forgetAuthModalReturn = (pathname) => {
    const saved = read_return();
    if (saved && normalize_path(pathname) !== saved.target) clear_return();
};
